/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostOperatorResetPasswordRequestBodyTypename = "PostOperatorResetPasswordRequestBody" as const;

/**
 *
 * @export
 * @interface PostOperatorResetPasswordRequestBody
 */
export interface PostOperatorResetPasswordRequestBody {
  /**
   *
   * @type {string}
   * @memberof PostOperatorResetPasswordRequestBody
   */
  email: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostOperatorResetPasswordRequestBody
   */
  readonly __typename?: string;
}

export function PostOperatorResetPasswordRequestBodyFromJSON(json: any): PostOperatorResetPasswordRequestBody {
  return PostOperatorResetPasswordRequestBodyFromJSONTyped(json, false);
}

export function PostOperatorResetPasswordRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostOperatorResetPasswordRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostOperatorResetPasswordRequestBodyTypename,

    email: json["email"],
  };
}

export function PostOperatorResetPasswordRequestBodyToJSON(object?: PostOperatorResetPasswordRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    email: value.email,
  };
}
